/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CustomerCreditsBaseDataFragment = {
  readonly __typename?: 'Customer';
  readonly id: string;
  readonly availableCredit: number;
  readonly useCredit: boolean;
};

export type CustomerCreditsDataFragment = {
  readonly __typename?: 'Credit';
  readonly id: string;
  readonly title: string;
  readonly remainingAmount: number;
  readonly expiresAt: string | null;
};

export type CustomerCreditsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CustomerCreditsQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly availableCredit: number;
    readonly useCredit: boolean;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'Credit';
      readonly createdAt: string;
      readonly id: string;
      readonly title: string;
      readonly remainingAmount: number;
      readonly expiresAt: string | null;
    }>;
  } | null;
};

export type CustomerCreditsWithNewFieldsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CustomerCreditsWithNewFieldsQuery = {
  readonly __typename?: 'Query';
  readonly currentCustomer: {
    readonly __typename?: 'Customer';
    readonly id: string;
    readonly availableCredit: number;
    readonly useCredit: boolean;
    readonly credits: ReadonlyArray<{
      readonly __typename?: 'Credit';
      readonly storefrontEligibilityTitle: string;
      readonly creditType: Types.CreditType;
      readonly id: string;
      readonly title: string;
      readonly remainingAmount: number;
      readonly expiresAt: string | null;
    }>;
  } | null;
};

export const CustomerCreditsBaseDataFragmentDoc = gql`
  fragment customerCreditsBaseData on Customer {
    id
    availableCredit
    useCredit
  }
`;
export const CustomerCreditsDataFragmentDoc = gql`
  fragment customerCreditsData on Credit {
    id
    title
    remainingAmount
    expiresAt
  }
`;
export const CustomerCreditsDocument = gql`
  query CustomerCredits {
    currentCustomer {
      ...customerCreditsBaseData
      credits {
        ...customerCreditsData
        createdAt
      }
    }
  }
  ${CustomerCreditsBaseDataFragmentDoc}
  ${CustomerCreditsDataFragmentDoc}
`;

export function useCustomerCreditsQuery(
  options?: Omit<Urql.UseQueryArgs<CustomerCreditsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<CustomerCreditsQuery, CustomerCreditsQueryVariables>({
    query: CustomerCreditsDocument,
    ...options,
  });
}
export const CustomerCreditsWithNewFieldsDocument = gql`
  query CustomerCreditsWithNewFields {
    currentCustomer {
      ...customerCreditsBaseData
      credits {
        ...customerCreditsData
        storefrontEligibilityTitle
        creditType
      }
    }
  }
  ${CustomerCreditsBaseDataFragmentDoc}
  ${CustomerCreditsDataFragmentDoc}
`;

export function useCustomerCreditsWithNewFieldsQuery(
  options?: Omit<
    Urql.UseQueryArgs<CustomerCreditsWithNewFieldsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    CustomerCreditsWithNewFieldsQuery,
    CustomerCreditsWithNewFieldsQueryVariables
  >({ query: CustomerCreditsWithNewFieldsDocument, ...options });
}
